<template>
  <!-- Start Slider Area  -->
  <div class="rn-slider-area demo_slider-area">
    <!-- Start Single Slide  -->
    <div
      class="slide slide-style-1 slider-fixed--height d-flex align-center bg_image codetime-hero-bg"
    >
      <!-- Hero background image prioritizada -->
      <img
        class="hero-priority-bg"
        :src="baseUrl + 'images/hero/analytics-hero.webp'"
        :srcset="baseUrl + 'images/hero/analytics-hero-768.webp 768w, ' + baseUrl + 'images/hero/analytics-hero-1280.webp 1280w, ' + baseUrl + 'images/hero/analytics-hero.webp 1920w'"
        sizes="(max-width: 768px) 100vw, (max-width: 1280px) 100vw, 100vw"
        alt=""
        fetchpriority="high"
        width="1920"
        height="1080"
        decoding="async"
      />
      <v-container class="position-relative">
        <v-row>
          <v-col cols="12">
            <div class="inner">
              <h1 class="heading-title theme-gradient">
                Sistema sob medida, <br> resultado no caixa
              </h1>
              <p class="description mt--20">
                Construímos soluções que economizam tempo e dinheiro
              </p>
            </div>
          </v-col>
        </v-row>
        <!-- End .row -->
        <!-- Start Service Area  -->
        <div class="service-wrapper service-white">
          <ServiceOne />
        </div>
        <!-- End Service Area  -->
      </v-container>
    </div>
    <!-- End Single Slide  -->
  </div>
  <!-- End Slider Area  -->
</template>

<script>
  import ServiceOne from "../../components/service/ServiceOne";
  export default {
    components: {
      ServiceOne,
    },
    computed: {
      baseUrl() {
        return process.env.BASE_URL || '/';
      }
    }
  };
</script>

<style lang="scss">
  .demo_slider-area {
    .slide.slide-style-1 .inner {
      padding-top: 40px;
    }
    
    /* Mobile - telas pequenas */
    @media (max-width: 767px) {
      .slide.slide-style-1 .inner {
        padding-top: 100px;
      }
    }
    
    /* Tablet - telas médias */
    @media (min-width: 768px) and (max-width: 959px) {
      .slide.slide-style-1 .inner {
        padding-top: 80px;
      }
    }
    
    .slide.slide-style-1 .inner .heading-title {
      font-size: clamp(32px, 6vw, 64px);
      line-height: 1.075;
      font-family: 'Poppins', sans-serif;
    }
    
    .slide.slide-style-1 .inner .description {
      font-size: clamp(16px, 2.2vw, 19px);
      color: rgba(255, 255, 255, 0.92);
      max-width: 860px;
      margin-left: auto;
      margin-right: auto;
    }
    
    @media only screen and (max-width: 991px) {
      .slider-fixed--height {
        padding-bottom: 70px;
      }
      .service-white .service__style--1 .content p {
        padding: 0 30px;
      }
    }
  }
  
  .demo_slider-area .codetime-hero-bg {
    position: relative;
    overflow: hidden;
    background: #000; /* fallback */
  }
  
  .demo_slider-area .hero-priority-bg {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    z-index: 0;
  }
  
  .demo_slider-area .codetime-hero-bg::before {
    content: "";
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.85);
    z-index: 1;
    pointer-events: none;
  }
  
  .demo_slider-area .codetime-hero-bg > .position-relative {
    position: relative;
    z-index: 2;
  }
  
  .slider-wrapper {
    .demo_slider-area {
      .service-wrapper {
        margin-bottom: 0;
      }
    }
  }
</style>
